<template>
  <div class="nav">
      <!-- :left-text="leftText" -->
      <!-- left-arrow -->
    <van-nav-bar
      :title="title"
      :right-text="rightText"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    rightText: {
      type: String,
      default: () => {
        return "";
      },
    },
    // leftText: {
    //   type: String,
    //   default: () => {
    //     return "返回";
    //   },
    // },
  },
  mounted() {},

  methods: {
    onClickLeft() {
      this.$emit("clickLeft");
    },
    onClickRight() {
      this.$emit("clickRight");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  width: 100%;
  .van-nav-bar {
    background: #86C3C4;
    color: #fff;
  }
  ::v-deep .van-nav-bar__text {
    color: #fff !important;
  }
  ::v-deep .van-nav-bar__title {
    color: #fff !important;
  }
  ::v-deep .van-icon-arrow-left {
    color: #fff !important;
  }
}
</style>